import React, { useEffect } from 'react';
import { Outlet } from 'react-router';
import { useData } from '@hooks/useData';
import { useGetUser } from '@services/useGetUser';

export const UserLocationStatus = () => {
    const { user, allSettings, login } = useData();
    const { request: requestUser } = useGetUser();

    // Convert the interval from settings, minutes to milliseconds
    const intervalMinutes = Number(allSettings?.data?.locationUpdateInterval) || 0;
    const intervalMs = intervalMinutes * 60 * 1000;
    const canCheckForStatusUpdates = login && intervalMinutes != 0 && user?.data.share_location === true;

    useEffect(() => {
        if (!canCheckForStatusUpdates) return;
        const intervalId = setInterval(() => {
            requestUser();
        }, intervalMs);

        return () => clearInterval(intervalId);
    }, [login, intervalMs, canCheckForStatusUpdates, user?.data.share_location]);

    return (
        <>
            <Outlet />
        </>
    );
};
